"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = require("prop-types");

var useQuery_1 = require("../hooks/useQuery");
/**
 * A component for executing a GraphQL-LD query.
 * @param {string | DocumentNode} query A GraphQL query, either a string, or pre-parsed.
 * @param {{[p: string]: any}} variables An optional hash of query variables.
 * @param {any} queryEngineOptions Optional query engine options.
 * @return {any}
 * @constructor
 */


function Query(_ref) {
  var query = _ref.query,
      children = _ref.children,
      _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? {} : _ref$variables,
      _ref$queryEngineOptio = _ref.queryEngineOptions,
      queryEngineOptions = _ref$queryEngineOptio === void 0 ? {} : _ref$queryEngineOptio;
  var result = useQuery_1.useQuery({
    query: query,
    variables: variables,
    queryEngineOptions: queryEngineOptions
  });
  return children && result ? children(result) : null;
}

exports.Query = Query;

(function (Query) {
  Query.propTypes = {
    query: prop_types_1.oneOfType([prop_types_1.string, prop_types_1.object]).isRequired,
    queryEngineOptions: prop_types_1.object,
    variables: prop_types_1.object
  };
})(Query = exports.Query || (exports.Query = {}));